import { FC, createContext } from 'react';
import { SchedulerInquiryContextProps } from './SchedulerInquiryContext.types';
import { initialState } from '../../components/SchedulerInquiry/schedulerInquiryReducer';
import { Inquiry } from '../../components/SchedulerInquiry/SchedulerInquiry.types';

export const SchedulerInquiryContext = createContext<Inquiry>(initialState);

const SchedulerInquiryContextProvider: FC<SchedulerInquiryContextProps> = (props: SchedulerInquiryContextProps) => {
  const { children, value } = props;
  return <SchedulerInquiryContext.Provider value={value}>{children}</SchedulerInquiryContext.Provider>;
};

export default SchedulerInquiryContextProvider;
